import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getProductRefData } from '../../../../../utils/plansReference';
import { Micro } from '../../../Typography';
import CommonDiscount from './commonDiscount';

const Spacing = styled.div`
  padding: ${({ padding }) => padding && padding.map((value) => `${value}px`).join(' ')};
`;

const VfDiscountSection = ({ plansReferenceData }) => {
  const planInfo = getProductRefData('VFDiscountSection', 'VFDiscountSection', plansReferenceData);
  const discountCreditPlanInfo = getProductRefData('VFCreditDiscountSection', 'VFCreditDiscountSection', plansReferenceData);
  const planName = planInfo && planInfo?.[0] && planInfo?.[0].VzDiscout;
  const charges = planInfo && planInfo?.[0] && planInfo?.[0].VzDiscoutCharges;
  const title = planInfo && planInfo?.[0] && planInfo?.[0].title;
  const vzPlanName = discountCreditPlanInfo && discountCreditPlanInfo?.[0] && discountCreditPlanInfo?.[0].VzDiscout;
  const vzPlanCharge = discountCreditPlanInfo && discountCreditPlanInfo?.[0] && discountCreditPlanInfo?.[0].VzDiscoutCharges;

  return (
    <>
      <CommonDiscount title={title} planName={planName} charges={charges} />
      <Spacing padding={[0, 0, 24, 0]} className="textAlignLeft">
        <Micro color="#6F7171">{planInfo && planInfo?.[0] && planInfo?.[0].disclaimerText}</Micro>
      </Spacing>
      {discountCreditPlanInfo.length > 0 && (
        <>
          <CommonDiscount planName={vzPlanName} charges={vzPlanCharge} />
          <Spacing padding={[0, 0, 24, 0]} className="textAlignLeft">
            <Micro color="#6F7171">{discountCreditPlanInfo && discountCreditPlanInfo?.[0] && discountCreditPlanInfo?.[0].disclaimerText}</Micro>
          </Spacing>
        </>
      )}
    </>
  );
};

export default VfDiscountSection;

VfDiscountSection.propTypes = {
  plansReferenceData: PropTypes.any,
};
